import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/core/services/utils.service';
import { ApiService } from 'src/app/core/services/api.service';
import { Component, Input, OnChanges, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';
import * as _ from 'lodash';
import { CurrentUserInfo } from 'src/app/core/models/currentUserInfo';
import { CURRENT_USER_ENDPOINT } from 'src/app/core/config/config.constants';

@Component({
  selector: 'app-sidenav-config',
  templateUrl: './sidenav-config.component.html',
  styleUrls: ['./sidenav-config.component.scss']
})
export class SidenavConfigComponent implements OnInit, OnChanges, OnDestroy {
  @Input() displayNavConf: boolean = false;
  @Output() closeNavConf = new EventEmitter<boolean>();
  @ViewChild('sidenav') sideNav: any;
  open = false;
  subscription: Subscription;
  stylesheetString = 'aft';
  currentUserInfo: CurrentUserInfo;
  constructor(
    private dataService: DataService,
    private utilsService: UtilsService,) { }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  ngOnChanges() {
    if (this.sideNav) {
      this.toggleNav();
    }
  }

  ngOnInit() {
    this.stylesheetString = this.utilsService.getStylesheetString();
    this.currentUserInfo = this.dataService.getCurrentUserInfo();
  }

  toggleNav() {
    console.log('Toggling displayNavConf', this.displayNavConf);
    if (this.displayNavConf) {
      this.sideNav.toggle();
    }else{
      this.sideNav.close();
    }
  }

  closeNav() {
    this.closeNavConf.emit(false);
  }
}
